import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import EditableContainer from '@v4/components/common/EditableContainer'
import EditableHTML from '@v4/components/common/EditableHTML'
import { Box, Grid } from '@material-ui/core'
import VideoBlock from '@v4/components/sections/Video/components/VideoBlock'
import PageMetaData from '@v4/utils/data/PageMetaData'
import Item from './components/Item'
import { useVideo9 } from './Video9.hooks'

const Video9 = props => {
	const [
		{
			classes,
			items,
			video,
			watchedItems,
			activeItemKey,
			isMobile,
			mobileAlignment,

			title,
			titleKey,
			titleConfig,
			titleEditable,
		},
		{ handleTitleClick, handleTitleChange, handleVideoClick },
	] = useVideo9(props)

	return (
		<>
			<EditableContainer
				visible={!!title}
				fieldConfig={titleConfig}
				onAdd={handleTitleChange}
				editable={titleEditable}
				wrapper={({ children }) => <Box className={clsx(classes.titleWrapper)}>{children}</Box>}
			>
				<EditableHTML
					key={titleKey}
					className={clsx(classes.title, 'video9-title-block')}
					html={title}
					onClick={handleTitleClick}
					editable={titleEditable}
					onChange={handleTitleChange}
				/>
			</EditableContainer>

			{!_.isEmpty(items) && (
				<Grid container spacing={isMobile ? 5 : 3}>
					<Grid item xs={12} sm={12} md={8} lg={8}>
						{video?.metaValue && (
							<div
								key={`${video.tierKey}_${video.index}`}
								className={clsx(classes.container, 'video9-video-container')}
							>
								<VideoBlock className="video9-video-block" value={video.metaValue} />
							</div>
						)}
					</Grid>

					<Grid item xs={12} sm={12} md={4} lg={4}>
						<div className={classes.listContainer}>
							<div className={classes.list}>
								{_.map(items, (key, index) => {
									return (
										<Item
											key={key}
											itemKey={key}
											active={activeItemKey === key}
											watched={watchedItems[key]}
											group="items"
											index={index}
											onVideoClick={handleVideoClick}
											mobileAlignment={mobileAlignment}
										/>
									)
								})}
							</div>
						</div>
					</Grid>
				</Grid>
			)}
		</>
	)
}

Video9.propTypes = {
	metaData: PropTypes.shape({
		title: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		backgroundDefault: PropTypes.instanceOf(PageMetaData),
		marginTop: PropTypes.instanceOf(PageMetaData),
		marginBottom: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Video9)
